import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Box,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';

const VerifyEmailChange: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  // Guard against double-fire — verification tokens are one-shot.
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setError('Invalid verification link');
        setLoading(false);
        return;
      }

      try {
        await api.post('/users/email/verify', { token });
        setSuccess(true);
      } catch (err: any) {
        setError(
          err.response?.data?.message || 'Failed to verify email change'
        );
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          Email Verification
        </Typography>

        {loading && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>Verifying your email...</Typography>
          </Box>
        )}

        {!loading && error && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
            <Button
              fullWidth
              variant="contained"
              onClick={() => navigate('/account-settings')}
            >
              Back to Account Settings
            </Button>
          </>
        )}

        {!loading && success && (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>
              Your email has been successfully updated!
            </Alert>
            <Button
              fullWidth
              variant="contained"
              onClick={() => navigate('/dashboard')}
            >
              Go to Dashboard
            </Button>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default VerifyEmailChange;
